import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "service/API";
import { setLoading } from "store/actionReducers/LoadingStore";
import { setStockFilterData } from "store/actionReducers/StockInvestStore";

const useStockInvest = () => {
  const dispatch = useDispatch();
  const StockInvestStore = useSelector((state: any) => state?.StockInvestStore);

  const GetInvestCategory = useCallback(async (param: any) => {
    dispatch(setLoading({ value: 'LoadListStockInvest' }))
    const res = await API.StockInvest.GetInvestCategory(param)
    if (res?.code === '0') {
      let dataOld = [...StockInvestStore?.StockFilterData]
      dataOld = dataOld.concat(res?.data?.data)
      dispatch(setStockFilterData(dataOld))
      dispatch(setLoading({ value: 'LoadListStockInvest' }))
    } else if (res?.code === '005') {
      dispatch(setStockFilterData([]))
      dispatch(setLoading({ value: 'LoadListStockInvest' }))
    }

  }, [StockInvestStore?.StockFilterData])

  return { GetInvestCategory }
}

export default useStockInvest